export default class ThemeSwitcher {
  constructor() {
    this.swhitcher = $('.theme-switcher');
  }

  listenEvents() {
    this.swhitcher.on('click', function() {
      const newTheme =
        $(document.documentElement).attr('data-theme') === 'dark'
          ? 'light'
          : 'dark';

      $(document.documentElement).attr('data-theme', newTheme);
      $(document.querySelector('iframe.hs-form-iframe'))
        .contents()
        .find('html')
        .attr('data-theme', newTheme);
      localStorage.setItem('rapydDocsTheme', newTheme);
    });
  }

  stopListening() {
    this.swhitcher.off('click');
  }
}
